// extracted by mini-css-extract-plugin
export var label = "_d4-1";
export var reminder = "_d4-0";